import { faker } from '@faker-js/faker'

export function getBodyWithFakeData(body: string) {
	// Match variables with or without spaces: {{variable}} or {{ variable }}
	const variableRegex = /{{\s*([^}\s]+)\s*}}/g

	let newBody = body

	// Use matchAll to get all matches
	for (const match of body.matchAll(variableRegex)) {
		const fullMatch = match[0] // e.g., "{{firstName}}" or "{{ firstName }}"
		const variableName = match[1] // e.g., "firstName"
		newBody = newBody.replace(fullMatch, guessFakerValue(variableName))
	}

	return newBody
}

export function guessFakerValue(field: string): string {
	const name = field.toLowerCase()

	if (name.includes('opentasks')) {
		return `
      <ul>
        <li><strong>Self Evaluation</strong> (John D.) - In Progress</li>
        <li><strong>Manager Review</strong> (Sarah M.) - Not Started</li>
      </ul>
    `
	}

	if (name.includes('alltasks')) {
		return `
      <ul>
        <li><strong>Self Evaluation</strong> (John D.) - In Progress</li>
        <li><strong>Manager Review</strong> (Sarah M.) - Not Started</li>
        <li><strong>Goal Setting</strong> (Jimmy F.) - Declined</li>
        <li><strong>Goal Setting</strong> (Jane R.) - Rejected</li>
        <li><strong>Goal Setting</strong> (John D.) - Completed</li>
      </ul>
    `
	}

	if (name.includes('closedtasks')) {
		return `
      <ul>
        <li><strong>Goal Setting</strong> (John D.) - Completed</li>
        <li><strong>Goal Setting</strong> (Jimmy F.) - Declined</li>
        <li><strong>Goal Setting</strong> (Jane R.) - Rejected</li>
      </ul>
    `
	}

	if (name.includes('cyclename')) return 'Q3 Performance Review 2024'

	if (name.includes('email')) return faker.internet.email()
	if (name.includes('first') && name.includes('name')) return faker.person.firstName()
	if (name.includes('last') && name.includes('name')) return faker.person.lastName()
	if (name.includes('name')) return faker.person.fullName()
	if (name.includes('phone') || name.includes('tel')) return faker.phone.number()
	if (name.includes('address') || name.includes('street')) return faker.location.streetAddress()
	if (name.includes('city')) return faker.location.city()
	if (name.includes('state')) return faker.location.state()
	if (name.includes('zip') || name.includes('postal')) return faker.location.zipCode()
	if (name.includes('country')) return faker.location.country()
	if (name.includes('company')) return faker.company.name()
	if (name.includes('job')) return faker.person.jobTitle()
	if (name.includes('title')) return faker.lorem.words(3)
	if (name.includes('price')) return faker.commerce.price()
	if (name.includes('date') || name.includes('created') || name.includes('updated'))
		return faker.date.recent().toLocaleDateString()
	if (name.includes('description') || name.includes('bio')) return faker.lorem.paragraph()
	if (name.includes('avatar')) return faker.image.avatar()

	return faker.word.words(1)
}
